import { fetchApi } from "../DataApi/fetchApi";
import { DB_NAME } from "../utilities/constants";

export async function authRequest(login, password) {
  // Create the request body
  const params = {
    db: DB_NAME,
    login,
    password,
  };

  try {
    // Prepare the request options
    const requestBody = JSON.stringify({ params });
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: requestBody,
      credentials: "omit",
    };

    const response = await fetchApi({
      requestOptions: options,
      endpoint: "/web/session/authenticate",
      checkSession: false,
    });

    // Extract relevant data from the response
    const data = JSON.parse(response);
    // console.log("session info", data);

    // Check for errors in the response
    if (data.error) {
      return { success: false, error: data.error };
    } else {
      // Return the successful response data
      const result = data.result;
      return {
        success: true,
        company_id: result.company_id,
        user_id: result.uid,
        company_partner_id: [result.uid],
        context: result.user_context,
        username: result.name,
        ...result,
      };
    }
  } catch (error) {
    // Handle any exceptions that occur during the request
    console.error("An error occurred:", error);
    return { success: false, error: error.message };
  }
}
